/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
  $getSelection,
  $isRangeSelection,
  $createTextNode,
} from 'lexical';
import { $createVariableNode } from '../../nodes/VariableNode';
import { VariableKey } from '../../types';

export const INSERT_VARIABLE_COMMAND: LexicalCommand<VariableKey> = createCommand('INSERT_VARIABLE_COMMAND');

export const VariablePlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_VARIABLE_COMMAND,
      (variableKey: VariableKey) => {
        const selection = $getSelection();

        if (!$isRangeSelection(selection)) {
          return false;
        }

        const variableNode = $createVariableNode(variableKey);
        const spaceNode = $createTextNode(' ');

        selection.insertNodes([variableNode, spaceNode]);

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
};
